export enum PassTemplateType {
  Standard = 0,
  Slim = 1,
  Square = 2,
}
